import { faCircle, faCircleCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';

import {
  CHECKLIST_ITEM_STATE_ACTIVE,
  CHECKLIST_ITEM_STATE_COMPLETE,
  CHECKLIST_ITEM_STATE_INCOMPLETE,
} from './constants';
import { checklistState } from './helpers/checkListState';

export {
  CHECKLIST_ITEM_STATE_ACTIVE,
  CHECKLIST_ITEM_STATE_COMPLETE,
  CHECKLIST_ITEM_STATE_INCOMPLETE,
  checklistState,
};

const ChecklistItemContainer = styled.div`
  border-radius: 5px;
  padding: 8px 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  background-color: rgba(233, 236, 239, 0.12);
`;

const ChecklistItemContainerActive = styled(ChecklistItemContainer)`
  background-color: rgba(230, 198, 68, 0.12);
`;

const ChecklistItemContainerComplete = styled(ChecklistItemContainer)`
  background-color: rgba(59, 182, 103, 0.12);
`;

const ChecklistIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5em;
  color: var(--gray-200);
`;

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const ChecklistIconActive = styled(ChecklistIcon)`
  color: var(--enosi-yellow);
  animation: ${spinAnimation} 1s linear infinite;
`;

const ChecklistIconComplete = styled(ChecklistIcon)`
  color: var(--enosi-green);
`;

/**
 * Renders a single checklist item with appropriate styling based on its state.
 * @param {object} props
 * @param {string} props.state The state of the checklist item
 * @param {string | React.ReactElement} props.label The label for the checklist item
 * @returns {React.ReactElement} A JSX element containing the checklist item
 */
function ChecklistItem({ state, label }) {
  switch (state) {
    case CHECKLIST_ITEM_STATE_ACTIVE:
      return (
        <ChecklistItemContainerActive>
          <ChecklistIconActive icon={faSpinner} />
          <span>{label}</span>
        </ChecklistItemContainerActive>
      );
    case CHECKLIST_ITEM_STATE_COMPLETE:
      return (
        <ChecklistItemContainerComplete>
          <ChecklistIconComplete icon={faCircleCheck} />
          <span>{label}</span>
        </ChecklistItemContainerComplete>
      );
    default:
      return (
        <ChecklistItemContainer>
          <ChecklistIcon icon={faCircle} />
          <span>{label}</span>
        </ChecklistItemContainer>
      );
  }
}

ChecklistItem.propTypes = {
  state: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
};

export default ChecklistItem;
